import { AuthRoutes } from "@/routes";

const AuthLayout = () => {
  return (
    <div className="h-full w-full relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-teal-950 via-teal-900 to-emerald-900 p-4 sm:p-6">
      {/* Decorative ambient glows */}
      <div className="pointer-events-none absolute -top-40 -left-24 size-96 rounded-full bg-teal-400/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 size-[28rem] rounded-full bg-emerald-300/10 blur-3xl" />
      <div className="pointer-events-none absolute top-1/3 left-1/2 size-72 -translate-x-1/2 rounded-full bg-cyan-300/10 blur-3xl" />

      <div className="relative grid w-full max-w-[980px] grid-cols-1 overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5 md:grid-cols-[1.05fr_1fr]">
        {/* Brand panel */}
        <div className="relative hidden flex-col justify-between overflow-hidden bg-gradient-to-br from-teal-900 to-emerald-950 p-10 text-white md:flex">
          {/* dotted texture */}
          <div
            className="absolute inset-0 opacity-[0.08]"
            style={{ backgroundImage: "radial-gradient(circle, #ffffff 1px, transparent 1px)", backgroundSize: "18px 18px" }}
          />
          <div className="pointer-events-none absolute -bottom-24 -left-12 size-72 rounded-full bg-emerald-400/10 blur-2xl" />

          <div className="relative w-fit rounded-2xl bg-white/95 px-5 py-3 shadow-lg backdrop-blur">
            <img src="/basisthan-long.png" alt="Basisthan" className="h-9" />
          </div>

          <div className="relative space-y-5">
            <h2 className="text-[28px] font-bold leading-tight tracking-tight">
              Run your hotel &amp; restaurant,
              <br />
              all from one place.
            </h2>
            <p className="max-w-sm text-sm leading-relaxed text-teal-100/80">
              Reservations, point of sale, live inventory, recipes and billing — unified in a single, calm workspace.
            </p>
            <ul className="space-y-3 pt-1">
              {[
                { icon: "fa-bell-concierge", text: "Front desk & POS" },
                { icon: "fa-boxes-stacked", text: "Live inventory & recipes" },
                { icon: "fa-file-invoice-dollar", text: "Invoices, payments & reports" },
              ].map((f) => (
                <li key={f.text} className="flex items-center gap-3 text-sm text-teal-50/90">
                  <span className="flex size-8 items-center justify-center rounded-lg bg-white/10 text-emerald-200 ring-1 ring-white/10">
                    <i className={`fas ${f.icon} text-xs`} />
                  </span>
                  {f.text}
                </li>
              ))}
            </ul>
          </div>

          <span className="relative text-[11px] text-teal-200/60">© Basisthan {new Date().getFullYear()}. All rights reserved.</span>
        </div>

        {/* Form panel */}
        <div className="flex min-h-[520px] flex-col justify-center bg-white px-7 py-10 sm:px-10">
          <div className="mb-8 flex justify-center md:hidden">
            <img src="/basisthan-long.png" alt="Basisthan" className="h-9" />
          </div>
          <AuthRoutes />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
